import { render, staticRenderFns } from "./AboutPageSlideshowComponent.vue?vue&type=template&id=639dd72a&scoped=true&"
import script from "./AboutPageSlideshowComponent.vue?vue&type=script&lang=ts&"
export * from "./AboutPageSlideshowComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AboutPageSlideshowComponent.vue?vue&type=style&index=0&id=639dd72a&scoped=true&lang=scss&"
import style1 from "./AboutPageSlideshowComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639dd72a",
  null
  
)

export default component.exports